import { onInitService } from "./init-service";
export { useAxios } from "./hooks/use-axios";
export { useJumpUrl } from "./hooks/use-jump-url";
export { useProxy } from "./hooks/use-proxy";
export { useTargetUrl } from "./hooks/use-target-url";

export const serviceAxios = () => [
  {
    target: "$INIT_SERVICE",
    handler: onInitService
  }
];
